<template>
  <span :data-icon="icon" :aria-hidden="decorative ? true : null" class="icon">
    <i :class="`icon-${icon}`" :aria-hidden="true" class="icon__icon" />

    <template v-if="!customLabel && !decorative">
      <a-label :path="labelPath" />
    </template>
    <span v-else-if="!decorative" class="a-visually-hidden">
      {{ customLabel }}
    </span>
  </span>
</template>

<script>
export default {
  compatConfig: {
    ATTR_FALSE_VALUE: false,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    labelPath: {
      type: String,
    },
    customLabel: {
      type: String,
    },
    decorative: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
